import { RouterConfigItem } from 'sdss/types/view'
import Homepage from 'sdss/views/HomeView'

export const HomepageRoute: RouterConfigItem = {
  name: 'Homepage',
  title: '首页',
  component: Homepage,
  path: '/',
  formatUrl(): string {
    return this.path
  }
}

export default [
  HomepageRoute,
]
